export default function <D>(d: D) {
    return d;
}